/**
 * Message attachment helpers (pending local uploads + display).
 */

import {
  EVIDENCE_ACCEPT,
  filterEvidenceFiles,
  mergeEvidenceFileNames,
  pendingEvidenceUrl,
  fileNamesFromEvidenceUrl,
} from './evidenceFiles.js';

export { EVIDENCE_ACCEPT as MESSAGE_ATTACHMENT_ACCEPT, filterEvidenceFiles as filterMessageAttachmentFiles };

export function messageAttachmentUrl(fileNames) {
  return pendingEvidenceUrl(fileNames);
}

export function fileNamesFromMessageAttachment(url) {
  return fileNamesFromEvidenceUrl(url);
}

export function mergeMessageAttachmentNames(existing, nextFiles) {
  return mergeEvidenceFileNames(existing, nextFiles);
}

/** Attachment file names stored on a message row. */
export function messageAttachmentNames(message = {}) {
  const row = message && typeof message === 'object' ? message : {};
  const fromUrl = fileNamesFromMessageAttachment(row.Attachment_URL);
  if (fromUrl.length) return fromUrl;
  if (Array.isArray(row.Attachments)) {
    return row.Attachments.map((item) => String(item?.name || '').trim()).filter(Boolean);
  }
  return [];
}

export function messageHasContent(body, attachmentNames = []) {
  return Boolean(String(body || '').trim()) || (attachmentNames || []).length > 0;
}

export function messagePreviewText(message = {}) {
  const row = message && typeof message === 'object' ? message : {};
  const body = String(row.Body || '').trim();
  if (body) return body;
  const names = messageAttachmentNames(row);
  if (!names.length) return '';
  if (names.length === 1) return `Attachment: ${names[0]}`;
  return `Attachments: ${names.length} files`;
}

export function buildLocalMessage({
  matterId,
  senderRole = 'CLIENT',
  senderName = 'You',
  body = '',
  attachmentNames = [],
}) {
  const names = (attachmentNames || []).map((n) => String(n || '').trim()).filter(Boolean);
  return {
    ROWID: `msg_local_${Date.now()}`,
    Matter_ID: matterId,
    Sender_Role: senderRole,
    Sender_Name: senderName,
    Body: String(body || '').trim(),
    Attachment_URL: messageAttachmentUrl(names),
    Created_At: new Date().toISOString(),
  };
}
